exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.time-badge[data-v-1c58974c] {\r\n    background-color: #17a2b8;\r\n    color: white;\r\n    padding: 4px 8px;\r\n    border-radius: 12px;\r\n    font-size: 0.8rem;\r\n    font-weight: 500;\n}\r\n", ""]);

// exports
